module.exports = "https://coursera_assets.s3.amazonaws.com/images/5ee5bde1f4ca2124f7a7086331fa8307.png";